import type { SVGProps } from "react";
import * as React from "react";

const SvgCornerLeftDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.707 15.707a1 1 0 0 0-1.414-1.414zM9 20l-.707.707a1 1 0 0 0 1.414 0zm-4.293-5.707a1 1 0 0 0-1.414 1.414zM20 5a1 1 0 1 0 0-2zm-7-1V3zM9 8H8zm4.293 6.293-5 5 1.414 1.414 5-5zm-3.586 5-5-5-1.414 1.414 5 5zM20 3h-7v2h7zm-7 0a5 5 0 0 0-3.536 1.464L10.88 5.88A3 3 0 0 1 13 5zM9.464 4.464A5 5 0 0 0 8 8h2a3 3 0 0 1 .879-2.121zM8 8v12h2V8z"
    />
  </svg>
);
export default SvgCornerLeftDown;
